import { render, staticRenderFns } from "./VideoCatelogueManage.vue?vue&type=template&id=a51bf51e&scoped=true"
import script from "./VideoCatelogueManage.vue?vue&type=script&lang=js"
export * from "./VideoCatelogueManage.vue?vue&type=script&lang=js"
import style0 from "./VideoCatelogueManage.vue?vue&type=style&index=0&id=a51bf51e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51bf51e",
  null
  
)

export default component.exports